/*eslint-disable */

import Vue from "vue";
import Router from "vue-router";
import AppLayout from "../components/admin/AppLayout";

Vue.use(Router);

const EmptyParentComponent = {
  template: "<router-view></router-view>",
};

var router = new Router({
  base:
    process.env.NODE_ENV === "production"
      ? `${process.env.VUE_APP_PRODUCTION_PATH}`
      : "/",
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: {
        name: "index"
      },
    },
    {
      name: "",
      path: "/",
      component: AppLayout,
      children: [
        {
          name: "index",
          path: "/",
          component: () => import("@/components/layout/survey/Main.vue"),
        },
        {
          name: "index/app",
          path: "/app/:mobile",
          component: () => import("@/components/layout/survey/Main.vue"),
        },
        {
          name: "powder",
          path: "/powder",
          component: () => import("@/components/layout/survey/Powder.vue"),
        },
        {
          name: "undertone",
          path: "/undertone",
          component: () => import("@/components/layout/survey/UnderTone.vue"),
        },
        {
          name: "finished",
          path: "/finished",
          component: () => import("@/components/layout/survey/Finished.vue"),
        },
        {
          name: "coupon",
          path: "/coupon",
          component: () => import("@/components/layout/survey/Coupon.vue"),
        },
        {
          name: "otp",
          path: "/otp",
          component: () => import("@/components/layout/survey/Otp.vue"),
        },
        {
          name: "color",
          path: "/color",
          component: () => import("@/components/layout/survey/Color.vue"),
        },
        {
          name: "powershade",
          path: "/powershade",
          component: () => import("@/components/layout/survey/PowderShade.vue"),
        }
      ],
    }
  ],
});

export default router;
